import styled from "styled-components";

export const MarkerInnerWrapper = styled.span<{ color: string }>`
    background-color: ${({ color }) => color};
`;

const ItemTitleWrapper = styled.div<{ color: string }>`
    color: ${({ color }) => color};
`;
